import { RolesService } from './../../../shared/service/roles.service';
import { CloudServiceAgreementService } from './../../../shared/service/cloud-service-agreement.service';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { AuthService } from 'src/app/auth.service';
import { Router, RouterEvent, NavigationEnd, RouterLink } from '@angular/router';
import { CommonService } from '../../../shared/service/common.service';
import { BlurHelperService } from '../../core/helpers/blur-helper.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToggleThemeService } from 'src/app/shared/service/toggle-theme.service';
import { AccountManagersModalComponent } from 'src/app/shared/components/account-managers-modal/account-managers-modal.component';
import { ShepherdService } from 'angular-shepherd';
import { steps as defaultSteps, defaultStepOptions } from 'src/app/tour-config';
import { CloudServiceAgreementComponent } from 'src/app/shared/components/cloud-service-agreement/cloud-service-agreement.component';
import { LocalStorageService } from '../../measure/services/measure/localstorage.service';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { ImpersonationService } from 'src/app/shared/service/impersonation.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ImpersonationBannerComponent } from '../../../shared/components/impersonation-banner/impersonation-banner.component';
import { BrandService } from 'src/app/shared/service/brand.service';

/* eslint-disable */

@Component({
    selector: 'nio-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatToolbarModule, CommonModule, MatButtonModule, RouterLink, MatMenuModule, MatIconModule, NgSelectModule, FormsModule, ReactiveFormsModule, MatSlideToggleModule, ImpersonationBannerComponent]
})
export class HeaderComponent implements OnInit {
  @Output() clickHamburger: EventEmitter<boolean> = new EventEmitter();
  isCollapsed = false;
  isLoggedIn = false;
  status = false;
  claims: any = null;
  rolesText: string | null = null;
  private getUserAccountsSub?: Subscription;
  accountsLoadedOnce = false;

  accounts = [];
  isAccountsLoaded = false;
  searchFn = (term: string, item: any) => {
    const q = (term || '').toLowerCase();
    return (
      (item.name || item.Name || '').toLowerCase().includes(q) ||
      (item.customer_id || '').toLowerCase().includes(q)
    );
  };
  selectedAccount;
  isLoading = true;
  isAdmin = false;
  demoModeControl = new FormControl();
  $getUserAccounts: any;
  roles;
  isCustomerAdmin = false;
  isNetsyncioUser = false;
  isPresalesEngineer = false;
  isAccountManager = false;
  assumeCidCtrl = new FormControl<string | null>(null);
  accountOptions: Array<{ customer_id: string; name?: string; Name?: string }> =
    [];
  customerId;
  private accountsLoaded = false;
  constructor(
    public router: Router,
    public commonService: CommonService,
    public blurHelper: BlurHelperService,
    public themeService: ToggleThemeService,
    public dialog: MatDialog,
    private shepherdService: ShepherdService,
    private roleService: RolesService,
    private authService: AuthService,
    private cloudAgreementService: CloudServiceAgreementService,
    private localStorageService: LocalStorageService,
    public imp: ImpersonationService,
    public brandService: BrandService
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isAuthenticated();
    if (this.isLoggedIn) this.loadAccountsOnce();
    this.claims = this.authService.getClaims();
    this.customerId = this.claims?.customer_id;
    this.isAdmin = this.roleService.checkIfUserIsAdmin();
    this.isNetsyncioUser = this.roleService.checkIfUserIsNormalUser();
    this.isCustomerAdmin = this.roleService.checkIfUserIsCustomerAdmin();
    this.isPresalesEngineer = this.roleService.checkIfUserIsPresalesEngineer();
    this.isAccountManager = this.roleService.checkIfUserIsAccountManger();

    // compute isLoggedIn once, then load

    this.authService?.events().subscribe((res) => {
      if (
        res?.type == 'token_received' ||
        res?.type == 'discovery_document_loaded'
      ) {
        setTimeout(() => {
          this.isAdmin = this.roleService.checkIfUserIsAdmin();
          this.isNetsyncioUser = this.roleService.checkIfUserIsNormalUser();
          this.isCustomerAdmin = this.roleService.checkIfUserIsCustomerAdmin();
          this.isPresalesEngineer =
            this.roleService.checkIfUserIsPresalesEngineer();
          this.isAccountManager = this.roleService.checkIfUserIsAccountManger();

          this.isLoggedIn = this.authService.isAuthenticated();
          this.claims = this.authService.getClaims();
          this.customerId = this.claims?.customer_id;

          if (this.isLoggedIn) {
            this.loadAccountsOnce();
          } else {
            this.accounts = [];
            this.isAccountsLoaded = false;
            this.accountsLoadedOnce = false;
          }
        }, 500);
      }
    });

    // this.isLoggedIn = this.router.url === '/';
    this.commonService.selectedAccountChanged.subscribe((account) => {
      this.selectedAccount = account;
      // this.commonService.selectedAccount.Id = account;
    });
    this.demoModeControl.setValue(this.blurHelper.enableBlur);

    // setTimeout(() => {
    //   const claims = this.authService.getClaims();
    //   // if (claims != null && this.authService.isAuthenticated()) {
    //   //   this.getAgreementAccpectanceStatus();
    //   // }
    // }, 2000);
  }

  /** one-shot accounts loader (idempotent) */
  private loadAccountsOnce(): void {
    if (this.accountsLoaded || this.getUserAccountsSub) return;

    // pick ONE: prefer cached; or keep original getAccounts (uncached)
    this.isLoading = true;
    // NOTE: the cached accounts stream can emit synchronously (shareReplay), and
    // template-bound state (isLoading / accounts) flipping inside another
    // component's change-detection pass triggers NG0100 in the header. Applying
    // that state on a macrotask keeps every mutation outside any active CD.
    this.getUserAccountsSub = this.commonService
      .getAccountsCached(false) // ✅ cached (recommended)
      // .getAccounts()                // ⛔ uncached; avoid unless you need fresh
      .pipe(
        take(1),
        finalize(() => setTimeout(() => (this.isLoading = false), 0))
      )
      .subscribe(
        (accounts: any[]) => {
          setTimeout(() => {
            this.accountsLoaded = true;
            this.isAccountsLoaded = true;
            this.accounts = accounts ?? [];

            // 🔽 build select options (adjust field names if needed)
            // ✅ Prefer customers_info for assume-customer dropdown
            this.accountOptions = (this.commonService.customersInfo || [])
              .map((c) => ({
                customer_id: c.customer_id,
                name: c.customer_name,
              }))
              .filter(
                (v, i, arr) =>
                  v.customer_id &&
                  arr.findIndex((x) => x.customer_id === v.customer_id) === i
              );

            const isClosedTour = localStorage.getItem('tourEnded');
            if (this.claims && this.accounts.length === 0 && !isClosedTour) {
              this.shepherdService.defaultStepOptions = defaultStepOptions;
              this.shepherdService.modal = true;
              this.shepherdService.confirmCancel = false;
              this.shepherdService.addSteps(defaultSteps);
              this.shepherdService.start();
            } else {
              this.endTour();
            }
          }, 0);
        },
        () => {
          this.commonService.selectedAccountChanged.next({
            Id: 'null',
            Name: 'null',
            Description: 'null',
          });
        }
      );
  }

  getAgreementAccpectanceStatus() {
    this.cloudAgreementService
      .getAgreementAcceptance(this.claims?.customer_id)
      .subscribe((data: any) => {
        this.status = data;
        if (this.status === false) {
          this.openCloudServiceAgreementModal();
        }
      });
  }

  ngAfterViewInit() {
    const isClosedTour = localStorage.getItem('tourEnded');
    if (this.claims !== null && this.accounts.length === 0 && !isClosedTour) {
      this.shepherdService.defaultStepOptions = defaultStepOptions;
      this.shepherdService.modal = true;
      this.shepherdService.confirmCancel = false;
      this.shepherdService.addSteps(defaultSteps);
      // this.shepherdService.start();
      this.router.events.subscribe((val) => {
        const event = val as RouterEvent;
        if (event instanceof NavigationEnd) {
          if (event.url.toString().includes('/deploy/cloud-formation-stack')) {
            this.endTour();
          }
        }
      });
    }
  }
  assumeSelected() {
    const cid = this.assumeCidCtrl.value;
    if (!cid) return;
    this.assume(cid); // your existing method
  }
  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.clickHamburger.emit(this.isCollapsed);
    this.commonService.clickHamburger.next(this.isCollapsed);
  }

  async onLogin(strategy: string = 'auth0') {
    if (
      !this.authService.isAzureIDP() &&
      new RegExp('azure', 'ig').test(strategy)
    ) {
      await this.authService.loginWithAzureAD();
    } else if (
      !this.authService.isAuth0IDP() &&
      new RegExp('auth0', 'ig').test(strategy)
    ) {
      await this.authService.loginWithAuth0();
    }
  }

  getImage() {
    return this.authService.isAzureIDP()
      ? '/assets/icons/azure-logo.png'
      : '/assets/icons/auth0-black-logo.png';
  }

  onLogoutClick() {
    this.authService.logout();
  }

  isUserLoggedIn() {
    return this.isLoggedIn;
  }

  // isUserLoggedIn() {
  //   this.isAdmin = this.roleService.checkIfUserIsAdmin();

  //   const isLoggedIn = this.authService.isAuthenticated();
  //   // this.router.url !== '/' && this.router.url.indexOf('redirect') === -1;
  //   const claims = this.authService.getClaims();
  //   if (
  //     isLoggedIn &&
  //     this.accounts.length === 0 &&
  //     !this.isAccountsLoaded &&
  //     !this.$getUserAccounts
  //   ) {
  //     if (
  //       this.isAdmin ||
  //       this.isCustomerAdmin ||
  //       this.isPresalesEngineer ||
  //       this.isAccountManager
  //     ) {
  //       this.$getUserAccounts = this.commonService?.getAccounts()?.subscribe(
  //         (accounts?) => {
  //           this.isLoading = false;
  //           this.isAccountsLoaded = true;
  //           this.accounts = accounts;
  //           const isClosedTour = localStorage?.getItem('tourEnded');

  //           //make check here.
  //           if (
  //             claims !== null &&
  //             this.accounts?.length === 0 &&
  //             !isClosedTour
  //           ) {
  //             this.shepherdService.defaultStepOptions = defaultStepOptions;
  //             this.shepherdService.modal = true;
  //             this.shepherdService.confirmCancel = false;
  //             this.shepherdService.addSteps(defaultSteps);
  //             this.shepherdService.start();
  //           } else {
  //             this.endTour();
  //           }
  //         },
  //         () => {
  //           this.isLoading = false;
  //           this.commonService.selectedAccountChanged.next({
  //             Id: 'null',
  //             Name: 'null',
  //             Description: 'null',
  //           });
  //         }
  //       );
  //     }

  //     if (this.isNetsyncioUser) {
  //       //new impelementation
  //       this.isLoading = true;

  //       if (claims !== null && this.authService.isAuthenticated()) {
  //         this.getUserAccountsSub = this.commonService
  //           .getAccounts()
  //           .pipe(
  //             take(1), // one-shot
  //             finalize(() => (this.isLoading = false))
  //           )
  //           .subscribe(
  //             (accounts: any) => {
  //               this.isLoading = false;
  //               this.isAccountsLoaded = true;

  //               this.accounts = accounts;

  //               const isClosedTour = localStorage.getItem('tourEnded');

  //               //make check here.
  //               if (
  //                 claims !== null &&
  //                 this.accounts?.length === 0 &&
  //                 !isClosedTour
  //               ) {
  //                 this.shepherdService.defaultStepOptions = defaultStepOptions;
  //                 this.shepherdService.modal = true;
  //                 this.shepherdService.confirmCancel = false;
  //                 this.shepherdService.addSteps(defaultSteps);
  //                 this.shepherdService.start();
  //               } else {
  //                 this.endTour();
  //               }
  //             },
  //             () => {
  //               this.isLoading = false;
  //               this.commonService.selectedAccountChanged.next({
  //                 Id: 'null',
  //                 Name: 'null',
  //                 Description: 'null',
  //               });
  //             }
  //           );
  //       }
  //     }
  //   }
  //   return isLoggedIn;
  // }

  canAccessAccounts() {
    return (
      this.router.url !== '/' &&
      this.router.url.indexOf('redirect') === -1 &&
      this.router.url.indexOf('unauthorized') === -1
    );
  }

  getClaims() {
    return this.authService.getClaims();
  }

  getRoles() {
    const claims = (this.getClaims() as any) || {};
    const rawRoles = claims.role;

    const rolesArr: string[] = Array.isArray(rawRoles)
      ? rawRoles
      : typeof rawRoles === 'string'
        ? [rawRoles]
        : [];

    const roles = rolesArr.map(r => (r || '').toLowerCase().trim());

    this.isCustomerAdmin = roles.includes('netsyncio customer admin');
    this.isPresalesEngineer = roles.includes('pre sales engineers');
    this.isAccountManager = roles.includes('netsync account manager');

    // ✅ only treat as admin if it's an actual admin role,
    // and explicitly exclude customer admin
    this.isAdmin =
      (roles.includes('admin') || roles.includes('netsyncio admin')) &&
      !this.isCustomerAdmin;

    this.isNetsyncioUser = roles.includes('netsyncio user');

    return rawRoles;
  }


  accountChange(event, account) {
    event.stopPropagation();
    // this.commonService.selectedAccount = account;
    // this.selectedAccount = account;
    this.commonService.selectedAccountChanged.emit(account);
  }

  demoModeHandler(event) {
    this.blurHelper.setBlur(event.checked);
  }

  toggleDarkMode(e) {
    // console.log('@DarkMode >>> ', e.checked);
    let activeMode = localStorage.getItem(this.themeService.THEME_KEY);
    if (e.checked) {
      this.themeService.setDarkTheme();
      activeMode = 'Dark Mode';
    } else {
      this.themeService.setLightTheme();
      activeMode = 'Light Mode';
    }
    // this.themeService.toggleTheme(false);
    const claims = this.localStorageService.get('id_token_claims_obj');
    // console.log('@claims >> header >> ', claims);
    if (claims && this.authService.isAuth0IDP()) {
      const requestData = {
        first_name: claims?.firstName,
        last_name: claims?.lastName,
        phone: claims?.phone,
        default_page: claims?.defaultPage,
        default_mode: activeMode,
        default_display_account: claims?.defaultDisplayAccount,
        picture: claims?.picture,
      };
      this.commonService
        .updateCustomerProfileInfo(requestData)
        .subscribe((data) => {
          let claims = this.localStorageService.get('id_token_claims_obj');
          claims.default_mode = activeMode;
          this.localStorageService.set('id_token_claims_obj', {
            ...claims,
          });
          // console.log('@activeMode >> ', activeMode);
          // console.log('@this.localStorageService.set(id_token_claims_obj >> ', this.localStorageService.get('id_token_claims_obj'));
        }),
        () => {
          this.commonService.errorMessage(
            'Something went wrong, Please try again later.'
          );
        };
    }
  }

  toggleDarkModeIcon(): void {
    if (this.themeService.isDarkThemeSelected) {
      this.themeService.setLightTheme();
    } else {
      this.themeService.setDarkTheme();
    }
    // Re-skin so the active brand recomputes its light / dark variant — the
    // template stays active in both modes (no reset).
    this.brandService.reapply();
  }


  assume(value: string | null) {
    const cid = (value || '').trim();
    if (!cid) return;
    const picked = this.accountOptions.find((x) => x.customer_id === cid);
    this.imp.assume(cid, picked?.name); // show name in banner if available
  }

  openAccountManagersModal() {
    let dialogRef = this.dialog.open(AccountManagersModalComponent, {
      width: '800px',
      height: '350px',
      autoFocus: false,
      panelClass: '',
      data: {
        accountsManagers: this.commonService.accountManagers,
      },
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  openCloudServiceAgreementModal() {
    if (this.claims != null && this.authService.isAuthenticated()) {
      let dialogRef = this.dialog.open(CloudServiceAgreementComponent, {
        width: '768px',
        height: '100%',
        panelClass: 'borderless-dialog',
        disableClose: true,
        hasBackdrop: false,
      });
      document.documentElement.classList.remove('cdk-global-scrollblock');

      dialogRef.afterClosed().subscribe((result) => { });
    }
  }

  private ensureTour(): void {
    if (!this.shepherdService?.tourObject) {
      this.shepherdService.defaultStepOptions = defaultStepOptions;
      this.shepherdService.modal = true;
      this.shepherdService.confirmCancel = false;
      this.shepherdService.addSteps(defaultSteps);
    }
  }

  startTour(): void {
    this.ensureTour();
    // start is safe even if already active; service handles it
    this.shepherdService.start();
  }

  endTour(): void {
    localStorage.setItem('tourEnded', 'true');

    const tour = this.shepherdService?.tourObject;
    // guard the internal tour object before calling service.complete()
    if (tour && (tour as any).isActive?.()) {
      this.shepherdService.complete(); // calls tourObject.complete()
    }
    // else: nothing to end
  }
}
